import type { ChartKey } from "./settings";
import type { ChartPoint } from "./types";

// チャート点から指定系列のY値を取り出す。
export const getSeriesY = (p: ChartPoint, key: ChartKey): number | null => {
  switch (key) {
    case "l1":
      return p.l1;
    case "l2":
      return p.l2;
    case "l3":
      return p.l3;
    case "l4":
      return p.l4;
    case "actual":
      return p.actual;
    default:
      return null;
  }
};
